module.exports = __webpack_public_path__ + "media/images/landkit/icons/social/twitter-5fc33c7d6d27b5603317f83861e02e88.svg";